import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DeleteUploadedFileService {

  constructor(private httpClient: HttpClient) { }

  deleteUploadedFile(fileId: number) {
    return this.httpClient.delete(`${environment.apiServer}/DeleteUploadedFile?documentId=${fileId}`);
  }
}
